var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWrong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 7,
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "white",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357 4763 l-357 -358 922 -922 923 -923 -923 -923 -922 -922 357 -358 358 -357 922 922 923 923 923 -923 922 -922 358 357 357 358 -922 922 -923 923 923 923 922 922 -357 358 -358 357 -922 -922 -923 -923 -923 923 -922 922 -358 -357z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrong);
export default __webpack_public_path__ + "static/media/wrong.a4dbcfc551524f39ab1f3165d650131a.svg";
export { ForwardRef as ReactComponent };